import { Injectable } from "@angular/core";
import {
    IDashboardSearchParameter, IOptionsWTranslatedString,
    ISearchParameterResponse
} from "libraries/interfaces/i-dashboard-config";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";

const year: number = new Date().getFullYear();
const month: number = new Date().getMonth();
const day: number = new Date().getDate();

@Injectable()
export class SearchParameterService {
    private params: IDashboardSearchParameter = {};

    private beginDate: Date = new Date(year - 1, month, day);
    private today: Date = new Date();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe
    ) {
    }

    public getParam(param: string, options?: IOptionsWTranslatedString[]): string | Date | string[] {
        if (param === 'dateB' && !this.params[param]) {
            this.params.dateB = this.beginDate;
        }
        if (param === 'dateE' && !this.params[param]) {
            this.params.dateE = this.today;
        }
        if (!this.params[param] && options?.length) {
            this.params[param] = options[0].value;
        }
        return this.params[param];
    }

    public setParams(param: IDashboardSearchParameter): void {
        Object.keys(param).forEach((keyArg: string): void => {
            const replacedKey: string = this.replaceDot(keyArg);
            this.params[replacedKey] = param[keyArg];
        });
        const queryParams: IDashboardSearchParameter = {};

        Object.keys(param).forEach((key: string): void => {
            if (param[key]) {
                const cleanedKey: string = this.retrieveDot(key);

                queryParams[cleanedKey] = typeof param[key] === "string" ?
                    param[key] :
                    Array.isArray(param[key]) ?
                        (param[key] as string[]).join(',') :
                    this.datePipe.transform((param[key] as Date), "YYYY-MM-dd");
            }
        });
        this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams,
            });
    }


    public getSearchParams(): ISearchParameterResponse {
        const ret: ISearchParameterResponse = {};
        Object.keys(this.params)
            .filter((keyArg: string): boolean => {
                if(Array.isArray(this.params[keyArg])){
                    return Boolean((this.params[keyArg] as string[])?.length);
                }
                return Boolean(this.params[keyArg]);
            })
            .forEach((keyArg: string): void => {
            const key: string = this.replaceDot(keyArg);
            if (this.params[key]) {
                const cleanedKey: string = this.retrieveDot(key);
                ret[cleanedKey] = typeof this.params[key] === 'string' ?
                    (this.params[key] as string) :
                    Array.isArray(this.params[key]) ?
                        (this.params[key] as string[]).join(',') :
                    this.params[key] ? this.datePipe.transform((this.params[key] as Date), "YYYY-MM-dd") : null;
            }
        });
        return ret;
    }

    public replaceDot(code: string): string {
        return code.replace(/\./g, '_dot_');
    }

    public retrieveDot(code: string): string {
        return code.replace(/_dot_/g, '.');
    }
}
